
export interface MapModel {
    address: string,
    street: string,
    state: string,
    streetNumber: number | undefined,
    postCode: string,
    city: string,
    entreCalles: string,
    depto: string,
    coordinates: {
        lon: number,
        lat: number
    },
    erpDistributorClientId?: string,
    erpDistributorClientName?: string,
}

export interface DirecGoogle {
    types: string [],
    formatted_address: string,
    address_components: AdressComponentGoogle[],
    partial_match: boolean,
    place_id: string,
    postcode_localities: string[],
    geometry: {
      location: {
        lat:number,
        lng:number,
      },
      location_type: string,
    }
}
export interface AdressComponentGoogle {
    short_name: string,
    long_name: string,
    postcode_localities: string[],
    types: string[],
}

export interface ResultGoogle {
    results: DirecGoogle[],
    status: string,
}

export const States: any[] = [
    { value: 'Buenos Aires', text: 'Buenos Aires' },
    { value: 'Catamarca', text: 'Catamarca' },
    { value: 'Chaco', text: 'Chaco' },
    { value: 'Chubut', text: 'Chubut' },
    { value: 'Córdoba', text: 'Córdoba' },
    { value: 'Corrientes', text: 'Corrientes' },
    { value: 'Entre Ríos', text: 'Entre Ríos' },
    { value: 'Formosa', text: 'Formosa' },
    { value: 'Jujuy', text: 'Jujuy' },
    { value: 'La Pampa', text: 'La Pampa' },
    { value: 'La Rioja', text: 'La Rioja' },
    { value: 'Mendoza', text: 'Mendoza' },
    { value: 'Misiones', text: 'Misiones' },
    { value: 'Neuquén', text: 'Neuquén' },
    { value: 'Río Negro', text: 'Río Negro' },
    { value: 'Salta', text: 'Salta' },
    { value: 'San Juan', text: 'San Juan' },
    { value: 'San Luis', text: 'San Luis' },
    { value: 'Santa Cruz', text: 'Santa Cruz' },
    { value: 'Santa Fe', text: 'Santa Fe' },
    { value: 'Santiago del Estero', text: 'Santiago del Estero' },
    { value: 'Tierra del Fuego', text: 'Tierra del Fuego' },
    { value: 'Tucumán', text: 'Tucumán' }
  ];

  export const regionMapAR: { aliases: string[]; name: string }[] = [
  { aliases: ['BUENOS AIRES', 'BS AS', 'PBA'], name: 'Buenos Aires' },
  { aliases: ['CATAMARCA'], name: 'Catamarca' },
  { aliases: ['CHACO'], name: 'Chaco' },
  { aliases: ['CHUBUT'], name: 'Chubut' },
  { aliases: ['CORDOBA', 'CÓRDOBA'], name: 'Córdoba' },
  { aliases: ['CORRIENTES'], name: 'Corrientes' },
  { aliases: ['ENTRE RIOS', 'ENTRE RÍOS'], name: 'Entre Ríos' },
  { aliases: ['FORMOSA'], name: 'Formosa' },
  { aliases: ['JUJUY'], name: 'Jujuy' },
  { aliases: ['LA PAMPA'], name: 'La Pampa' },
  { aliases: ['LA RIOJA'], name: 'La Rioja' },
  { aliases: ['MENDOZA'], name: 'Mendoza' },
  { aliases: ['MISIONES'], name: 'Misiones' },
  { aliases: ['NEUQUEN', 'NEUQUÉN'], name: 'Neuquén' },
  { aliases: ['RIO NEGRO', 'RÍO NEGRO'], name: 'Río Negro' },
  { aliases: ['SALTA'], name: 'Salta' },
  { aliases: ['SAN JUAN'], name: 'San Juan' },
  { aliases: ['SAN LUIS'], name: 'San Luis' },
  { aliases: ['SANTA CRUZ'], name: 'Santa Cruz' },
  { aliases: ['SANTA FE'], name: 'Santa Fe' },
  { aliases: ['SANTIAGO DEL ESTERO', 'ESTERO', 'SANTIAGO'], name: 'Santiago del Estero' },
  { aliases: ['TIERRA DEL FUEGO', 'FUEGO', 'TDF'], name: 'Tierra del Fuego' },
  { aliases: ['TUCUMAN', 'TUCUMÁN'], name: 'Tucumán' },
  { aliases: ['CABA', 'CIUDAD AUTONOMA DE BUENOS AIRES', 'CIUDAD DE BUENOS AIRES'], name: 'Ciudad Autónoma de Buenos Aires' }
];

export const mendozaCities: string[] = [];

export const distributorCities = [
  "villa tulumaya",
  "los corralitos",
  "mendoza",
  "godoy cruz",
  "dorrego",
  "las heras",
  "russel",
  "luzuriaga",
  "villa nueva",
  "guaymallen",
  "lujan de cuyo",
  "villa hipodromo",
  "el algarrobal",
  "san jose",
  "rodeo de la cruz",
  "maipu",
  "carrodilla",
  "bermejo",
  "tres esquinas cruz d",
  "gutierrez",
  "perdriel",
  "jesus nazareno",
  "lunlunta",
  "colonia segovia",
  "barrancas",
  "cacheuta",
  "potrerillos",
  "cruz de piedra mendo",
  "el challao",
  "rodeo del medio",
  "colonia bombal",
  "palmira",
  "san roque",
  "costa de araujo",
  "agrelo",
  "nueva california",
  "3 de mayo",
  "el sauce",
  "fray luis beltran",
  "chacras de coria",
  "gustavo andres",
  "ugarteche",
  "benegas",
  "coquimbito",
  "lavalle",
  "mayor drummond",
  "la primavera",
  "no aplica",
  "blanco encalada",
  "jocoli",
  "eugenio bustos",
  "las vegas",
  "uspallata",
  "la puntilla",
  "buena nueva",
  "las compuertas",
  "km.11",
  "km 11",
  "km11",
  "tunuyan",
  "el salto",
  "la pega",
  "vistalba",
  "panquehua",
  "rivadavia",
  "medrano",
  "san martin",
  "colonia junin",
  "junin",
  "ingeniero giacnoni",
  "los barriales",
  "la colonia",
  "alto verde",
  "tupungato",
  "la consulta",
  "vista flores"
];